module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"targetPeriod":"Target period"},"ja":{"targetPeriod":"対象期間"},"zh-hant":{"targetPeriod":"目標期間"},"zh-hans":{"targetPeriod":"目标期间"}}')
  delete Component.options._Ctor
}
